import { View } from "@react-pdf/renderer"
import React, { CSSProperties } from "react"
import { CellProps } from "../Cell/Cell"

export interface RowProps {
    children: React.ReactElement<CellProps>[] | React.ReactElement<CellProps>
    border?: string
    backgroundColor?: string
    width?: string
    style?: CSSProperties
    /**
     * Marca la fila como encabezado de la tabla: si la tabla se parte entre paginas,
     * react-pdf la vuelve a dibujar arriba del pedazo que cae en la siguiente hoja.
     */
    fixed?: boolean
}

const Row = ({
    children,
    border,
    width,
    backgroundColor,
    style,
    fixed,
}: RowProps) => {
    return (
        <View
            // la prop solo puede existir cuando es true: react-pdf mira si la llave esta
            // presente, no su valor, y un `fixed={undefined}` impediria el salto de pagina
            {...(fixed ? { fixed: true } : {})}
            style={{
                width: width ? width : "100%",
                backgroundColor,
                display: "flex",
                border,
                flexDirection: "row",
                ...style as any,
            }}
        >
            {children}
        </View>
    )
}

export default Row
